import * as React from 'react';
import { Row } from 'reactstrap';
import { ICase } from 'src/share/types/case/case';
import './childrenForm.css'
import { IChildrenSelector, IAlertInfo } from '../Create/types';
import * as _ from 'lodash';
import { ChildOptions } from 'src/modules/Alert/ChildrenForm/components/ChildOptions';


export interface IChildrenSelectorProps {
  caseInfo: ICase;
  alertInfo: IAlertInfo;
  isEdit: boolean;
  disabled: boolean
  setValue: (path: string, value: any) => void;
}

export interface IChildrenSelectorState {
  loading: boolean;
  childrenIds: string[]
}

export default class ChildrenForm extends React.PureComponent<IChildrenSelectorProps, IChildrenSelectorState> {
  constructor(props: IChildrenSelectorProps) {
    super(props);
    this.state = {
      loading: false,
      childrenIds: []
    }
  }

  public switchHandler = (childId: string) => {
    const { childrenSelector = {} } = this.props.alertInfo;
    const isValidChild = this.isValidChild(childId);
    return {
      checked: childrenSelector[childId] && childrenSelector[childId].selected,
      onChange: (e: boolean) => {
        if (isValidChild && !this.props.isEdit && !this.props.disabled) {
          this.props.setValue(`childrenSelector.${childId}.selected`, e)
        }

      }
    }
  }
  public static getDerivedStateFromProps(props: IChildrenSelectorProps, state: IChildrenSelectorState) {
    const childrenIds = props.caseInfo.children.map((child) => child.childId);
    return {
      childrenIds
    }
  }
  public componentDidUpdate(prevProps, prevState) {
    if (!this.props.isEdit && !_.isEqual(_.sortBy(prevState.childrenIds), _.sortBy(this.state.childrenIds))) {
      this.props.setValue('childrenSelector', ChildrenForm.loadChildrenSelector(this.props.caseInfo))
    }
  }

  public static loadChildrenSelector(caseInfo: ICase) {
    return caseInfo.children.reduce((childrenSelector, child) => {
      const [portrait = "", alternate = "", progressed = ""] = child.images || []
      const imageUrl = portrait || alternate || progressed
      childrenSelector[child.childId] = {
        selected: !!imageUrl,
        currentImage: imageUrl
      };
      return childrenSelector;
    }, {} as IChildrenSelector);
  }

  public checkIfChildIsSelected(childId: string) {
    const { childrenSelector = {} } = this.props.alertInfo;
    return childrenSelector[childId] && childrenSelector[childId].selected;
  }


  public isValidChild(childId: string) {
    const { childrenSelector = {} } = this.props.alertInfo;
    return childrenSelector[childId] && childrenSelector[childId].currentImage;
  }

  public imageForm(childId: string, imageUrl: string) {
    const noPhotoURL = "https://s3.us-east-2.amazonaws.com/caseview-children-assets/Images/no_photo_found.jpg"
    const imageIsSelect = this.checkImageSelected(childId, imageUrl) ? 'image-selected' : ''
    const childIsNotSelect = !this.checkChildIsSelected(childId) ? 'child-not-selected' : ''
    const isDisabled = this.props.disabled && imageIsSelect ? 'disabled' : ''
    const imageClasses = [imageIsSelect, childIsNotSelect, isDisabled];
    return {
      src: imageUrl || noPhotoURL,
      className: imageClasses.join(' '),
      onClick: () => {
        if (imageUrl && !!!childIsNotSelect && !this.props.disabled) {
          this.props.setValue(`childrenSelector.${childId}`, {
            currentImage: imageUrl,
            selected: true
          })
        }
      }
    }
  }

  public checkImageSelected(childId: string, imageUrl: string) {
    const { childrenSelector = {} } = this.props.alertInfo;
    return childrenSelector[childId] && childrenSelector[childId].currentImage === imageUrl;
  }
  public checkChildIsSelected(childId: string) {
    const { childrenSelector = {} } = this.props.alertInfo;
    return childrenSelector[childId] && childrenSelector[childId].selected;
  }
  public getImage = (childId: string, image: string, showNoImage = false) => {
    return image || showNoImage ? (
      <img alt="portrait" {...this.imageForm(childId, image)} />
    ) : null
  }
  public render() {
    const { caseInfo, alertInfo, isEdit } = this.props
    const { childrenSelector = {} } = alertInfo;
    if (caseInfo && caseInfo.children && Object.keys(childrenSelector || {}).length > 0) {
      const childrenSelected = Object.keys(childrenSelector).filter((childId) => childrenSelector[childId].selected)
      const childLength = isEdit ? childrenSelected.length : caseInfo.children.length;
      return (
        <>
          <Row>
            <h5>{childLength > 1 ? "Children" : "Child"} information and alert {childLength > 1 ? "images" : "image"}:</h5>
          </Row>
          <Row>
            <div className="children-selector-container">
              <Row>
                {
                  this.props.caseInfo.children.map((child) => {
                    return (
                      <ChildOptions
                        key={child.childId}
                        child={child}
                        childrenSelector={childrenSelector}
                        getImage={this.getImage}
                        isEdit={isEdit}
                        switchHandler={this.switchHandler}
                      />
                    )
                  })
                }
              </Row>
            </div>
          </Row>
        </>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/Alert/ChildrenForm/ChildrenForm.tsx